import { useState } from "react";
import GoogleAuth from "./GoogleAuth";
import GooglePhotos from "./GooglePhotos";

function GooglePhotoSelector({setSelectedImages, maxHeight = '500px', maxWidth = '1000px'}) {
    const [accessToken, setAccessToken] = useState(null);
  
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
        <GoogleAuth onAuthSuccess={setAccessToken} />
        {accessToken && (
          <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <GooglePhotos accessToken={accessToken} setSelectedImages={setSelectedImages} maxHeight={maxHeight} maxWidth={maxWidth} />
          </div>
        )}
      </div>
    );
  }
  
  export default GooglePhotoSelector;
  